import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ContactOtherPage } from '@/pages/contact/other/ContactOther/ContactOtherPage';
/**
 * その他のお問い合わせページ（認証以外のアクセス制限）
 * NOTE: ページ構成統一のため作成してあります。アクセス制限等ができた場合ここに処理を追加する
 */
export const ContactOther = (props) => {
    const { changeFormState, formState, types } = props;
    return (_jsx(ContactOtherPage, { changeFormState: changeFormState, formState: formState, types: types }));
};
